import {CURRENT_AFFILIATE_UPDATE, CURRENT_HASH_UPDATE} from '../constants/ActionTypes';
import { AFFILIATE_SERVICE_URL } from '../constants/api';
import { CALL_API } from '../login/api.middleware';
import * as type from '../constants/ActionTypes';


export function updateCurrentAffiliate(currentAffiliate) {

  return {
    type: CURRENT_AFFILIATE_UPDATE,
    currentAffiliate
  };
}

export function updateCurrentHash(hash) {

  return {
    type: CURRENT_HASH_UPDATE,
    hash
  };
}



export function affiliateMemberRequest(selectedClientId, formDetails) {

  //ADD PARAM CHECK!!!!

  const body = {
    clientId: selectedClientId,
    name: formDetails.name,
    vatNumber: formDetails.vatNumber,
    vatNumberType: formDetails.vatNumberType,
    website: formDetails.website,
    contactEmail: formDetails.contactEmail,
    affiliateExternalId: formDetails.affiliateExternalId,
    contactTelephone: formDetails.contactTelephone,
    billingStreetName: formDetails.streetName,
    billingCity: formDetails.city,
    billingState: formDetails.state,
    billingPostCode: formDetails.postCode,
    billingCountry: formDetails.country,
    ibanCode: formDetails.ibanCode,
    acceptedTerms: formDetails.acceptedTerms
  };

  let config = {
    method: 'POST',
    body: JSON.stringify(body)
  };

  return {
    [CALL_API]: {
      endpoint: `${AFFILIATE_SERVICE_URL}/affiliates`,
      types: [
        type.AFFILIATE_MEMBER_REQUEST,
        type.AFFILIATE_MEMBER_SUCCESS,
        type.AFFILIATE_MEMBER_FAILURE
      ],
      config,
      authenticated: true
    }
  };
}


export function cleanAffiliateList() {
  return {
    type: type.CLEAN_AFFILIATE_LIST
  };
}